import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
import { Message } from "element-ui";
const participants = {
  state: () => ({
    items: [],
    validationErrors: [],
    detailedFilter: false,
    timeout: null,
    selectedPrintSchemeID: null,
    registrationInputs: [],
    selectedRegistrationInputs: [],
    setFirstItem: null,
    showRegistrationInputs: false,
    liveStreamFilter: {
      searchTerm: null,
      skip: 0,
      take: 1000,
      total: 0,
      page: 1,
      ids: []
    },
    lastSelectecFormId: null,
    automatedMessageId: null,
    automatedMessageType: null,
    activeSubEventIndex: 0,
    activeAccompayingIndex: 0,
    activeAdditionalServiceIndex: 0,
    filter: {
      packetIds: [],
      registrationFormId: null,
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
      checkIn: null,
      isCardPrinted: null,
      voucherSendStatus: null,
      voucherTaskStatus: null,
      automatedMessageId: null,
      automatedMessageType: null,
      automatedMessageLogStatus: null,
      additionalServiceIds: [],
      additionalServiceStatus: null,
      additionalProductIds: [],
      additionalProductStatus: null,
      voucherType: null,
      activationStatus: null,
      dayRestriction: null,
      minimumCheckInDate: null,
      groupIDs: null,
      activationCode: null,
      paymentType: null,
      maximumCheckInDate: null,
      paymentStatus: null,
      promotionIDs: null,
      tagIDs: null,
      subEventIDs: null,
      couponCode: null,
      paymentID: null,
      minCardPrintDate: null,
      maxCardPrintDate: null,
      minCheckInDate: null,
      maxCheckInDate: null,
      checkInDateRange: null,
      cardDateRange: null,
      venueMinDate: null,
      venueMaxDate: null,
      venueDateRange: null,
      venueID: null,
      createDateRange: null,
      createDateMaxDate: null,
      createDateMinDate: null
    },
    selectedItems: [],
    loading: true
  }),
  mutations: {
    setParticipantFirstItem(state, payload) {
      state.setFirstItem = payload;
    },
    setPrintSchemeId(state, payload) {
      state.selectedPrintSchemeID = payload;
    },
    setParticipantValidationErrors(state, payload) {
      state.validationErrors = payload;
    },
    setParticipants(state, payload) {
      if (payload.items.length > 0) {
        for (var i = 0; i < payload.items.length; i++) {
          payload.items[i].checked = state.selectedItems.some(x => x.id == payload.items[i].id);
        }
      }

      state.items = payload.items;
      if (payload.items.length > 0) {
        state.setFirstItem = payload.items[0].id;
      } else {
        state.setFirstItem = null;
      }
      state.filter.total = payload.totalCount;
    },
    setRegistrationInputs(state, payload) {
      state.registrationInputs = payload.items;

      state.registrationInputs.map(item => {
        if (state.selectedRegistrationInputs.some(k => k == item.id) && item.isActive == false) {
          var index = state.selectedRegistrationInputs.findIndex(k => k == item.id);
          state.selectedRegistrationInputs.splice(index, 1);
        }
      });

      setTimeout(() => {
        localStorage.getItem("rInputs", JSON.stringify(state.selectedRegistrationInputs));
      }, 50);
    },
    setSelectedParticipants(state, payload) {
      state.selectedItems = payload.items;
    },
    setParticipantPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getParticipants");
    },
    setParticipantTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getParticipants");
    },
    setOneParticipant(state, payload) {
      var fIndex = state.items.findIndex(x => x.id == payload.id);
      console.log(fIndex, "setOneParticipant", payload.id);
      if (fIndex != -1) {
        state.items[fIndex] = payload;
      }
    }
  },
  actions: {
    async addProxyParticipant(store, payload) {
      var res = await axios.post("participant/addproxy", payload);
      store.commit("setParticipantValidationErrors", res.data.validationErrors);

      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async participantBlock(store, payload) {
      var res = await axios.post("participant/toggleisblocked", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async sendVoucherParticipant(store, payload) {
      var res = await axios.post("participant/sendvoucher", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        store.state.automatedMessageId = payload.automatedMessageId;
        store.state.automatedMessageType = payload.type;
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async sendCertificateParticipant(store, payload) {
      var res = await axios.post("participant/sendcertificate", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async getBulkParticipants(store, payload) {
      store.state.liveStreamFilter.ids = payload;
      var res = await axios.post("participant/list", store.state.liveStreamFilter);
      return res.data.data.items;
    },
    async refreshActivationCode(store, payload) {
      var res = await axios.post("/Participant/RefreshActivationCode", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async saveProfilePictureParticipant(store, payload) {
      var res = await axios.post("participant/updateimage", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async addParticipantNote(store, payload) {
      var res = await axios.post("/Participant/AddNote", payload);
      store.commit("setParticipantValidationErrors", res.data.validationErrors);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async addOrUpdateParitipant(store, payload) {
      var res = await axios.post("/Participant/AddOrUpdate", payload);
      store.commit("setParticipantValidationErrors", res.data.validationErrors);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async setParticipantProfilePicture(store, payload) {
      var res = await axios.post("event/uploadImage?uploadType=participantProfile", payload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: axios.defaults.headers["Authorization"]
        }
      });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }

      return res;
    },
    async getParticipantOne(store, payload) {
      var res = await axios.post("participant/get", { id: payload });
      if (!res.data.alert.hasError) {
        // store.dispatch('getParticipants');
      }
      return res;
    },
    async participantPrintCard(store, payload) {
      var res = await axios.post("participant/print", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async getParticipants(store) {
      clearTimeout(store.state.timeout);

      store.state.timeout = setTimeout(async () => {
        store.state.loading = true;
        var res = await axios.post("participant/list", { ...store.state.filter, skip: (store.state.filter.page - 1) * store.state.filter.take });
        store.state.loading = false;
        return store.commit("setParticipants", res.data.data);
      }, 25);
    },
    async toggleParticipant(store, payload) {
      var res = await axios.post("participant/toggleisblocked", {
        id: store.state.items[payload.index].id
      });

      return res.data;
    },
    async participantConfirmSubEvent(store, payload) {
      var res = await axios.post("participant/confirmsubeventregistration", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async participantCancelSubEvent(store, payload) {
      var res = await axios.post("participant/cancelsubeventregistration", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async changeParticipantStatus(store, payload) {
      var res = await axios.post("participant/changepaymentstatus", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async changeAccompayingPersonStatus(store, payload) {
      var res = await axios.post("participant/ChangeAccompayingPersonStatus", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async changeAdditionalServiceStatus(store, payload) {
      var res = await axios.post("participant/ChangeAdditionalServiceStatus", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async deleteParticipant(store, payload) {
      var res = await axios.post("participant/delete", {
        id: payload
      });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        await store.dispatch("getParticipants");
      }
      return res;
    },
    async checkIn(store, payload) {
      var res = await axios.post("participant/checkin", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        store.dispatch("getParticipants");
      }
      return res;
    }
  },
  getters: {
    getParticipantsItems: state => state.items,
    getParticipantValidation: state => state.validationErrors,
    getParticipantFirstItem: state => state.setFirstItem,
    getParticipantFilter: state => state.filter
  }
};
export default participants;



// WEBPACK FOOTER //
// ./src/store/participants.js